<template>
  <!-- eslint-disable max-len -->
  <svg
    :height="size"
    :width="size"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M18.4426 25.468H8.23817C7.03468 25.468 6.06378 24.3352 6.06378 22.931L6.06378 6.17515C6.06378 4.77097 7.03468 3.63818 8.23817 3.63818L18.4426 3.63818C19.6461 3.63818 20.617 4.77097 20.617 6.17515V22.9428C20.6069 24.3352 19.636 25.468 18.4426 25.468Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'CardIcon',
  props: ['size'],
}
</script>
